import classNames from 'classnames';
import { ReactNode } from 'react';

type TProps = {
  isActive: boolean;
  text: string | ReactNode;
  icon?: ReactNode;
  onClick: () => void;
};

export const ToolbarButton = ({ isActive, text, icon, onClick }: TProps) => {
  return (
    <div
      onClick={onClick}
      className={classNames(
        't-h-[30px] t-cursor-pointer t-rounded-lg t-bg-white t-px-5 t-text-xs t-font-bold t-outline t-outline-1 t-transition t-duration-200',
        {
          't-border t-border-brand-black t-py-[6px] t-outline-brand-black': isActive,
          't-border t-border-neutrals-light-grey t-py-[6px] t-outline-transparent hover:t-border-brand-black hover:t-outline-brand-black':
            !isActive,
        }
      )}>
      <div className='t-flex t-items-center t-gap-2'>
        {icon}
        <span>{text}</span>
      </div>
    </div>
  );
};
